import React from 'react';
import { useNavigate } from 'react-router-dom';
import CheckInScanner from '../components/CheckInScanner';

const CheckInPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-24 pb-12">
      <div className="max-w-md mx-auto px-4 mb-4">
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-purple-600 hover:text-purple-700 font-medium flex items-center"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
      </div>
      <CheckInScanner />
    </div>
  );
};

export default CheckInPage;
